import { Navigate, useSearchParams } from 'router-v6'
import { getSafeRedirectUrl } from 'v2/utils/url-validation'

// Old console login page: carry its `?next=` to /login as `next_url` so the user still lands
// on that page after signing in.
export const LegacyLoginRedirect = () => {
  const [searchParams] = useSearchParams()
  const next = getSafeRedirectUrl(searchParams.get('next'))
  return <Navigate to={next ? `/login?next_url=${encodeURIComponent(next)}` : '/login'} replace />
}
